import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingFormComponent } from './booking-form/booking-form.component';
import { BookingOverviewComponent } from './booking-overview/booking-overview.component';
import { BookingConfirmationComponent } from './booking-confirmation/booking-confirmation.component';
import { TranslocoModule } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { CartridgeFeatureBookingRoutingModule } from './cartridge-feature-booking-routing.module';
import { BookingStepComponent } from './booking-step/booking-step.component';
import { CartridgeDataAccessModule } from '@markant-platform/cartridge/data-access';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BookingHeaderComponent } from './booking-header/booking-header.component';
import { CartridgeFeatureCmsBackgroundModule } from '@markant-platform/cartridge/feature-cms-background';
import { CartridgeUiPriceModule } from '@markant-platform/cartridge/ui-price';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { SharedDialogFeatureModule } from '@markant-platform/shared/dialog/feature';
import { BookingComponent } from './booking/booking.component';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { ScrollIndicatorDirective } from '@markant-platform/shared/util-scroll';
import { DefaultValuePipe, FormControlErrorPipe, FormControlKeyErrorPipe } from '@markant-platform/shared/util-pipes';
import {
  InfoListComponent,
  InfoListItemComponent,
  WizardBodyColumnComponent,
  WizardBodyComponent,
  OfferLinkComponent,
} from '@markant-platform/cartridge/ui-booking';
import { ContractPartnerInfoComponent } from './booking-form/booking-form-content/contract-partner-info/contract-partner-info.component';
import { BillingInfoComponent } from './booking-form/booking-form-content/billing-info/billing-info.component';
import { ReferencesInfoComponent } from './booking-form/booking-form-content/references-info/references-info.component';
import { BookingFormContentComponent } from './booking-form/booking-form-content/booking-form-content.component';

@NgModule({
  imports: [
    CommonModule,
    CartridgeFeatureBookingRoutingModule,
    TranslocoModule,
    MarkantElementsModule,
    CartridgeDataAccessModule,
    FormsModule,
    ReactiveFormsModule,
    CartridgeFeatureCmsBackgroundModule,
    CartridgeUiPriceModule,
    SharedDialogFeatureModule,
    ModalBridgeComponent,
    TranslocoCurrencyPipe,
    ScrollIndicatorDirective,
    DefaultValuePipe,
    FormControlErrorPipe,
    FormControlKeyErrorPipe,
    InfoListComponent,
    InfoListItemComponent,
    ContractPartnerInfoComponent,
    BillingInfoComponent,
    ReferencesInfoComponent,
    WizardBodyComponent,
    WizardBodyColumnComponent,
    BookingFormContentComponent,
    OfferLinkComponent,
  ],
  declarations: [
    BookingFormComponent,
    BookingOverviewComponent,
    BookingConfirmationComponent,
    BookingStepComponent,
    BookingHeaderComponent,
    BookingComponent,
  ],
})
export class CartridgeFeatureBookingModule {}
